<!-- total-balance.html -->
<div class="bank-widget" [class.size-small]="size === 'small'">
  <!-- Top Section -->
  <div class="bank-t">
    <div class="bank-top">
      <div class="bank-left">
        <img [src]="displayAccount?.logo || 'assets/icons/img-bank.svg'" class="bank-icon"
          [alt]="displayAccount?.bankName || 'Bank'" />
        <span class="bank-name">{{ displayAccount?.bankName || 'All Account Banks' }}</span>
      </div>
      <div class="bank-f">
        <button class="bank-setting" type="button" (click)="toggleSettings($event)" cdkOverlayOrigin
          #settingsTrigger="cdkOverlayOrigin">
          <img src="assets/icons/settings-light.svg" alt="Settings" />
        </button>

        <!-- Settings Dropdown -->
        <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="settingsTrigger"
          [cdkConnectedOverlayOpen]="isSettingsOpen" [cdkConnectedOverlayOffsetY]="10"
          (overlayOutsideClick)="closeSettings()">
          <div class="select-bank-AC" (click)="$event.stopPropagation()">
            <div class="frame">
              <div class="title">Select Bank Account</div>
              <div class="footer" (click)="confirmSettings($event)">
                <div class="button">Done</div>
              </div>
            </div>

            <div class="select-bank-scroll">
              <div class="div" style="cursor: default;">
                <div class="frame-2">
                  <div class="balance-comparison-wrapper">
                    <div class="balance-comparison">All Account Banks</div>
                  </div>
                  <div class="views-value">{{ allSavingsBalance | currency:'INR' }}</div>
                </div>
              </div>

              <!-- List of Banks -->
              <ng-container *ngFor="let acc of accounts">
                <div [ngClass]="temporarySelectedBankId === acc.id ? 'frame-3' : 'div'"
                  (click)="temporarySelectedBankId = acc.id" style="cursor: pointer;">
                  <div class="frame-2">
                    <div class="balance-comparison-wrapper">
                      <div class="balance-comparison">{{ acc.bankName }}</div>
                    </div>
                    <div class="views-value">{{ acc.balance | currency:'INR' }}</div>
                  </div>
                  <!-- Only show setting icon for specific banks as per design, consistent in both selected/unselected states -->
                  <div class="huge-icon-interface-wrapper">
                    <img class="img" src="assets/icons/img_setting.svg" />
                  </div>
                </div>
              </ng-container>
            </div>

            <!-- Footer -->
            <div class="footer-2" (click)="openAddBankModal($event)" [class.disabled]="isAddingBank">
              <ng-container *ngIf="!isAddingBank">
                <div class="text-wrapper">Add New Bank Account</div>
                <img class="img" src="assets/icons/img_user-add.svg" alt="Add"
                  onerror="this.src='assets/icons/img_setting.svg'" />
              </ng-container>
              <ng-container *ngIf="isAddingBank">
                <div class="text-wrapper">Opening Onemoney...</div>
                <div class="spinner-small"></div>
              </ng-container>
            </div>
          </div>
        </ng-template>

        <ng-container *ngIf="isEditMode">
          <div class="pencil-wrapper" (click)="toggleSizeDropdown(index, $event)" cdkOverlayOrigin
            #editTrigger="cdkOverlayOrigin">
            <img src="assets/icons/img-pencil.svg" class="pencil-icon" alt="Edit size" />
          </div>
          <app-widget-edit [editTrigger]="editTrigger" [index]="index" [activeDropdownIndex]="activeDropdownIndex"
            [getAvailableSizes]="getAvailableSizes" [changeWidgetSize]="changeWidgetSize" [removeWidget]="removeWidget"
            [toggleSizeDropdown]="toggleSizeDropdown">
          </app-widget-edit>
        </ng-container>
        <ng-container *ngIf="isAddMode">
          <img class="add-widget-btn no-dark-filter" src="assets/icons/img_frame-1171275385.png" alt="Settings"
            (click)="addWidget.emit(); $event.stopPropagation()" />
        </ng-container>
      </div>
    </div>

    <!-- Balance -->
    <div class="bank-amount">{{ totalBalance | currency:'INR' }}</div>

    <!-- Account Row -->
    <div class="bank-account-row">
      <span class="label" *ngIf="size !== 'small'">{{ displayAccount?.type || 'Savings' }}:</span>
      <span class="label">{{ displayAccount?.accountNumber || '**** ****' }}</span>
      <div class="account-btn" (click)="toggleDropdown($event)" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
        <span>Accounts</span>
        <img src="assets/icons/img-direction-up-01.svg" alt="" />
      </div>
    </div>
  </div>

  <!-- Bottom Buttons -->
  <div class="bank-actions">
    <button *ngIf="size === 'small'" class="action-btn" type="button" (click)="openTransferFund($event)">
      <span>Transfer</span>
      <div class="icon-circle">
        <img src="assets/icons/img-up-arrow-01.svg" alt="" />
      </div>
    </button>

    <ng-container *ngIf="size !== 'small'">
      <button class="action-btn" type="button" (click)="toggleSendDropdown($event)" cdkOverlayOrigin
        #sendTrigger="cdkOverlayOrigin">
        <span>Send</span>
        <img src="assets/icons/img-up-arrow-01.svg" alt="" />
      </button>
      <button class="action-btn" type="button">
        <span>Receive</span>
        <img src="assets/icons/img-down-arrow-01.svg" alt="" />
      </button>
      <button class="action-btn more-btn" type="button" (click)="toggleRecentTransactions($event)" cdkOverlayOrigin
        #moreTrigger="cdkOverlayOrigin">
        <img src="assets/icons/img-more-horizontal.svg" alt="More" />
      </button>

      <!-- Send Money Dropdown (Moved inside ng-container for scope) -->
      <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="sendTrigger"
        [cdkConnectedOverlayOpen]="isSendDropdownOpen" [cdkConnectedOverlayOffsetY]="10"
        (overlayOutsideClick)="closeSendDropdown()">
        <div class="transfer-mini" (click)="$event.stopPropagation()">
          <div class="frame">
            <div class="component">
              <div class="title">Send Money</div>
              <footer class="footer" (click)="closeSendDropdown($event)">
                <div class="button">Close</div>
              </footer>
            </div>
          </div>
          <div class="div">
            <div class="frame-2" (click)="openSendUpiModal($event)">
              <div class="img-wrapper"><img class="img" src="assets/icons/img_up-arrow-01.svg" /></div>
              <div class="heading-why-banxx-wrapper">
                <div class="heading-why-banxx">Send UPI</div>
              </div>
              <div class="huge-icon-arrows-wrapper">
                <img class="huge-icon-arrows" src="assets/icons/img_direction-right-01.svg" />
              </div>
            </div>
            <div class="frame-2" (click)="openBankAccountModal($event)">
              <div class="img-wrapper"><img class="img" src="assets/icons/img_users-01.svg" /></div>
              <div class="heading-why-banxx-wrapper">
                <div class="heading-why-banxx">To Bank Account</div>
              </div>
              <div class="huge-icon-arrows-wrapper">
                <img class="huge-icon-arrows" src="assets/icons/img_direction-right-01.svg" />
              </div>
            </div>
            <div class="frame-2" (click)="openOwnAccountModal($event)">
              <div class="img-wrapper"><img class="img" src="assets/icons/img_connection.svg" /></div>
              <div class="heading-why-banxx-wrapper">
                <div class="heading-why-banxx">To Own Account</div>
              </div>
              <div class="huge-icon-arrows-wrapper">
                <img class="huge-icon-arrows" src="assets/icons/img_direction-right-01.svg" />
              </div>
            </div>
            <div class="frame-2" (click)="openScanQrModal($event)">
              <div class="img-wrapper"><img class="img" src="assets/icons/img_qr-scan.svg" /></div>
              <div class="heading-why-banxx-wrapper">
                <div class="heading-why-banxx">Scan QR Code</div>
              </div>
              <div class="huge-icon-arrows-wrapper">
                <img class="huge-icon-arrows" src="assets/icons/img_direction-right-01.svg" />
              </div>
            </div>
          </div>
        </div>
      </ng-template>

      <!-- Recent Transactions Dropdown (Moved inside ng-container for scope) -->
      <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="moreTrigger"
        [cdkConnectedOverlayOpen]="isRecentTransactionsOpen" [cdkConnectedOverlayOffsetY]="10"
        (overlayOutsideClick)="closeRecentTransactions()">
        <div class="recent-transactions" (click)="$event.stopPropagation()">
          <div class="frame">
            <div class="component">
              <div class="title">Recent transactions</div>
              <footer class="footer" (click)="navigateToTransactions($event)">
                <div class="button">See All</div>
              </footer>
            </div>
            <div class="div">
              <div class="frame-2">
                <img class="huge-icon-user-solid" src="assets/icons/img_user1.svg" />
                <div class="balance-comparison">{{ displayAccount?.accountNumber || '**** ****' }}</div>
              </div>
              <div class="filter">
                <div class="icon-button" (click)="previousTransactionPage()">
                  <img class="huge-icon-arrows" src="assets/icons/img_arrow-right-22.svg" />
                </div>
                <div class="icon-button" (click)="nextTransactionPage()">
                  <img class="huge-icon-arrows" src="assets/icons/img_arrow-right1.svg" />
                </div>
              </div>
            </div>
            <div class="frame-3">
              <div class="component-2" *ngFor="let tx of paginatedRecentTransactions">
                <div [class]="tx.amount < 0 ? 'component-3' : 'component-4'"></div>
                <div class="frame-4">
                  <div class="frame-wrapper">
                    <div class="frame-5">
                      <div class="products-value">{{tx.title}}</div>
                      <div class="div-2">
                        <div class="date-range">{{tx.date}}</div>
                        <div class="date-range">{{tx.time}}</div>
                      </div>
                    </div>
                  </div>
                  <div class="component-wrapper">
                    <div class="div-2">
                      <div [class]="tx.amount < 0 ? 'views-value' : 'text-wrapper'">
                        {{tx.amount > 0 ? '+' : ''}}{{tx.amount | currency:'INR':'symbol':'1.2-2'}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="frame-6">
              <div class="div-2">
                <div class="text-wrapper-2">Weekly payment limit</div>
                <div class="ellipse"></div>
                <div class="text-wrapper-3">₹{{weeklyLimit | number:'1.2-2'}} / ₹{{maxWeeklyLimit | number:'1.0-0'}}
                </div>
              </div>
              <div class="rectangle-wrapper">
                <div class="rectangle" [style.width.%]="(weeklyLimit / maxWeeklyLimit) * 100"></div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </ng-container>
  </div>

  <!-- Account Selection Dropdown -->
  <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="isDropdownOpen"
    [cdkConnectedOverlayOffsetY]="10" (overlayOutsideClick)="closeDropdown()">
    <div class="property-select" (click)="$event.stopPropagation()">
      <div class="component">
        <div class="title">Select Card</div>
        <div class="footer" (click)="closeDropdown($event)">
          <div class="button">Done</div>
        </div>
      </div>

      <div class="frame-wrapper">
        <div class="div">
          <div class="footer-2" [class.active]="activeTab === 'Accounts'" (click)="switchTab('Accounts')">
            <div class="text-wrapper">Accounts</div>
          </div>
          <div class="footer-2" [class.active]="activeTab === 'Credit Cards'" (click)="switchTab('Credit Cards')">
            <div class="text-wrapper">Credit Cards</div>
          </div>
        </div>
      </div>

      <div class="property-scroll-area">
        <div class="frame">
          <!-- All Cards Option (Non-clickable header) -->
          <div class="frame-2" style="cursor: default;">
            <div class="frame-3">
              <div class="balance-comparison-wrapper">
                <div class="balance-comparison">
                  {{ activeTab === 'Accounts' ? 'All Cards' : 'All Credit Cards' }}
                </div>
              </div>
              <div class="views-value">{{ (activeTab === 'Accounts' ? allSavingsBalance : allCreditCardsBalance) |
                currency:'INR' }}</div>
              <div class="used-amount" *ngIf="activeTab === 'Credit Cards'">
                Used: {{ allCreditCardsUsed | currency:'INR' }}
              </div>
            </div>
          </div>

          <!-- Individual Accounts -->
          <ng-container *ngFor="let acc of currentList">
            <div class="frame-2 account-row" [class.selected-account]="temporarySelectedBankId === acc.id"
              (click)="temporarySelectedBankId = acc.id" style="cursor: pointer;">
              <div class="frame-3">
                <div class="frame-4">
                  <div class="balance-comparison">{{ acc.bankName }}</div>
                  <div class="balance-comparison-2">{{ acc.accountNumber }}</div>
                </div>
                <div class="views-value" [class.positive-balance]="activeTab === 'Credit Cards'"
                  [class.negative-balance]="acc.balance < 1 && activeTab === 'Credit Cards'">
                  {{ acc.balance | currency:'INR' }}
                </div>
                <div class="used-amount" *ngIf="acc.usedAmount">
                  Used: {{ acc.usedAmount | currency:'INR' }}
                </div>
              </div>
              <div class="huge-icon-interface-wrapper" (click)="$event.stopPropagation(); removeAccount(acc.id)">
                <img class="img" src="assets/icons/img_trash.svg" alt="Delete" />
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <div class="footer-4" (click)="openAddBankModal($event)" [class.disabled]="isAddingBank">
        <ng-container *ngIf="!isAddingBank">
          <div class="text-wrapper-3">Add New Card</div>
          <img class="img" src="assets/icons/img-card.svg" alt="Add" />
        </ng-container>
        <ng-container *ngIf="isAddingBank">
          <div class="text-wrapper-3">Connecting...</div>
          <div class="spinner-small"></div>
        </ng-container>
      </div>
    </div>
  </ng-template>
</div>